export default __webpack_public_path__ + "static/media/TIWAP_Medium.91b30059.md";